<!-- Aqui empieza el contenido de la pagina -->
<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">Quality Control</h4>
			</div>
			<div class="card-body">
				<div *ngIf="!leadsLoading && !selectedLead" class="col-md-12 ml-auto mr-auto">
					<div class="col-md-12 ml-auto mr-auto">
						<div class="row">
							<div class="title float-left col-md-12 ml-auto mr-auto">
								<h3><i class="ri-team-fill"></i>{{ leads.length }} Leads(s)</h3>
							</div>
							<div class="col-md-12 float-right mt-4">
								<!-- Buttons Group -->
								<div class="btn-group" role="group" aria-label="Basic example">
									<button (click)="toggleLeadsList('unreviewed')" [class.active]="selectedOptions.qcControl.selectedTab === 'unreviewed'" class="btn btn-primary">Unreviewed {{ totalUnreviewed }}</button>

									<button (click)="toggleLeadsList('overproduced')" [class.active]="selectedOptions.qcControl.selectedTab === 'overproduced'" class="btn btn-primary">Overproduced {{ totalOverproduced }}</button>

									<button (click)="toggleLeadsList('fix')" [class.active]="selectedOptions.qcControl.selectedTab === 'fix'" class="btn btn-primary">Fix {{ totalFix }}</button>

									<button (click)="toggleLeadsList('approved')" [class.active]="selectedOptions.qcControl.selectedTab === 'approved'" class="btn btn-primary">Approved {{ totalApproved }}</button>

									<button (click)="toggleLeadsList('denied')" [class.active]="selectedOptions.qcControl.selectedTab === 'denied'" class="btn btn-primary">Denied {{ totalDenied }}</button>
								</div>
							</div>
						</div>
					</div>

					<!-- SEARCH NORMAL -->
					<div class="row mt-4">
						<div class="col-2">
							<label for="">Agent</label>
							<select [(ngModel)]="selectedOptions.qcControl.agent" class="form-control" (change)="selectSearch()">
								<option value="All" selected>All</option>
								<option value="{{ userSelect.login }}" *ngFor="let userSelect of employeeUsers">
									{{ userSelect.name }}
								</option>
							</select>
						</div>

						<div class="col-2">
							<label for="">Campaign</label>
							<select [(ngModel)]="selectedOptions.qcControl.campaign" class="form-control" (change)="selectSearch()">
								<option value="0" selected>All</option>
								<option value="{{ campaign.id }}" *ngFor="let campaign of campaigns">
									{{ campaign.name }}
								</option>
							</select>
						</div>
						<div class="col-2">
							<label for="">Date</label>
							<select [(ngModel)]="selectedOptions.qcControl.dateBy" class="form-control" (change)="selectSearch()">
								<option value="date_generated" selected>Appt Date</option>
								<option value="lead_creation">Creation Date</option>
							</select>
						</div>
						<div class="col-2">
							<label for="">Replacement Status</label>
							<select [(ngModel)]="selectedOptions.qcControl.replacement_status" class="form-control" (change)="selectSearch()">
								<option value="All" selected>All</option>
								<option value="QC Calls">QC Calls</option>
								<option value="Pending Reschedule">Pending Reschedule</option>
								<option value="Rescheduled">Rescheduled</option>
								<option value="Pending Replacement">Pending Replacement</option>
								<option value="Replaced">Replaced</option>
							</select>
						</div>

						<div class="col-4">
							<label for="">Date Range</label>
							<!-- ======================================================= -->
							<app-form-range-date [(ngModel)]="dateRange_" (OnSelected)="dateSelected($event)" [position]="'left'"></app-form-range-date>
						</div>
					</div>

					<br />

					<!-- Tabla nueva -->
					<div>
						<div class="row">
							<div class="col-8">
								<p style="margin: 0px; padding: 0px; font-size: 11px">Hide Columns (Click on the column You want to See):</p>
								<p>
									<span *ngFor="let column of columns" class="badge" (click)="toggleColumn(column.prop)" [ngClass]="{ 'bg-primary': column.visible, 'bg-danger': !column.visible }" style="cursor: pointer; margin-right: 5px">
										{{ column.name }}
									</span>
								</p>
							</div>
							<div class="col-2">
								<label for="">Rows per page</label>
								<select [(ngModel)]="rowPerPage" class="form-control" (change)="reloadTable()">
									<option value="10" selected>10</option>
									<option value="50">50</option>
									<option value="100">100</option>
									<option value="500">500</option>
									<option value="1000">1000</option>
								</select>
							</div>
							<div class="col-2" align="right">
								<button (click)="exportToExcel()" type="button" class="btn btn-success btn-label waves-effect waves-light export-btn">
									<i class="ri-file-excel-fill label-icon align-middle fs-16 me-2"></i>
									Export
								</button>
							</div>
						</div>
						<ngx-datatable
						class="material"
						[rows]="leads"
						class="material"
						[columnMode]="ColumnMode.force"
						[footerHeight]="50"
						[headerHeight]="50"
						rowHeight="auto" [scrollbarH]="true" [limit]="rowPerPage">
							<!-- Row Number Column -->
							<ngx-datatable-column [width]="60" [sortable]="false" [canAutoResize]="false" headerClass="cell-center title-header" cellClass="cell-center" name="#">
								<ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
									{{ rowIndex + 1 }}
								</ng-template>
							</ngx-datatable-column>
							<!-- ID Column -->
							<ngx-datatable-column [width]="90" [sortable]="true" [canAutoResize]="false" headerClass="cell-center title-header" cellClass="cell-center" name="Id" prop="id" *ngIf="isShowed('id')">
								<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
									<a (click)="editLead(row)" class="text-primary" style="cursor: pointer">
										{{ value }}
									</a>
								</ng-template>
							</ngx-datatable-column>

							<!-- Creation date Column -->
							<ngx-datatable-column [width]="120" [sortable]="true" headerClass="title-header" name="Creation date" prop="lead_creation" *ngIf="isShowed('lead_creation')">
								<ng-template let-value="value" ngx-datatable-cell-template>
									{{ value | utcToLocal : "mediumDate" }}
								</ng-template>
							</ngx-datatable-column>

							<!-- Agent Column -->
							<ngx-datatable-column [width]="110" [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center" name="Agent" prop="generated_by" *ngIf="isShowed('generated_by')"> </ngx-datatable-column>

							<!-- Appt Date Column -->
							<ngx-datatable-column [width]="220" [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center" name="Appt Date" prop="date_generated" *ngIf="isShowed('date_generated')">
								<ng-template let-value="value" ngx-datatable-cell-template>
									{{ value | date : "medium" }}
								</ng-template>
							</ngx-datatable-column>

							<!-- Phone Column -->
							<ngx-datatable-column [width]="120" [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center" name="Phone" prop="primary_phone" *ngIf="isShowed('primary_phone')"> </ngx-datatable-column>

							<!-- Prospect Column -->
							<ngx-datatable-column [width]="250" [sortable]="true" headerClass="title-header" cellClass="padding-0" name="Prospect" prop="prospect_company" *ngIf="isShowed('prospect_company')">
								<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
									<div [ngClass]="getBgColor(row.lead_status, row.replacement_status)" style="cursor: pointer; width: 100%; height: 100%; padding: 2px 5px 5px 5px" (dblclick)="editLead(row)">
										{{ value }}
									</div>
								</ng-template>
							</ngx-datatable-column>

							<!-- Status Column -->
							<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center" name="Status" prop="replacement_status" *ngIf="isShowed('replacement_status')"> </ngx-datatable-column>

							<!-- Replaced by Column -->
							<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Replaced by" prop="replaced_by" *ngIf="isShowed('replaced_by')"> </ngx-datatable-column>

							<!-- Meet Type Column -->
							<ngx-datatable-column [width]="100" [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Meet Type" prop="meet_type" *ngIf="isShowed('meet_type')"> </ngx-datatable-column>

							<!-- Difficulty Column -->
							<ngx-datatable-column [width]="80" [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Difficulty" prop="difficult" *ngIf="isShowed('difficult')"> </ngx-datatable-column>

							<!-- Qualified Column -->
							<ngx-datatable-column [width]="80" [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Qualified" prop="calificado" *ngIf="isShowed('calificado')"> </ngx-datatable-column>

							<!-- Campaign Column -->
							<ngx-datatable-column [width]="150" [sortable]="true" headerClass="title-header" cellClass="" name="Campaign" prop="campaign_name" *ngIf="isShowed('campaign_name')"> </ngx-datatable-column>

							<!-- Billed Column -->
							<ngx-datatable-column [width]="80" [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Billed" prop="payed" *ngIf="isShowed('payed')"> </ngx-datatable-column>

							<!-- Free type Column -->
							<ngx-datatable-column [width]="90" [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Free type" prop="free_type" *ngIf="isShowed('free_type')"> </ngx-datatable-column>

							<!-- Confirmation Column -->
							<ngx-datatable-column [width]="120" [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Confirmation" prop="confirmation" *ngIf="isShowed('confirmation')"> </ngx-datatable-column>

							<!-- Hidden columns (visible: false in the configuration) -->
							<!-- These columns are included but with hidden property -->

							<!-- Time Zone Column -->
							<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Time Zone" prop="time_zone" *ngIf="isShowed('time_zone')"> </ngx-datatable-column>

							<!-- Replaced for Column -->
							<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Replaced for" prop="replace_for" *ngIf="isShowed('replace_for')"> </ngx-datatable-column>

							<!-- Prospect Name Column -->
							<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Prospect Name" prop="prospect_name" *ngIf="isShowed('prospect_name')"> </ngx-datatable-column>

							<!-- City Column -->
							<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="City" prop="city" *ngIf="isShowed('city')"> </ngx-datatable-column>

							<!-- State Column -->
							<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="State" prop="state" *ngIf="isShowed('state')"> </ngx-datatable-column>

							<!-- Zip Column -->
							<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Zip" prop="zip" *ngIf="isShowed('zip')"> </ngx-datatable-column>

							<!-- Email Column -->
							<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Email" prop="primary_email" *ngIf="isShowed('primary_email')"> </ngx-datatable-column>

							<!-- Employee Size Column -->
							<ngx-datatable-column [sortable]="true" [hidden]="true" cellClass="" name="Employee Size" prop="employee_size" *ngIf="isShowed('employee_size')"> </ngx-datatable-column>

							<!-- Time In status Column -->
							<ngx-datatable-column [sortable]="true" cellClass="" name="Time In status" prop="change_date" *ngIf="isShowed('change_date')">
								<ng-template let-value="value" ngx-datatable-cell-template>
									{{ value | dateAgo }}
								</ng-template>
							</ngx-datatable-column>
						</ngx-datatable>
					</div>

					<div></div>
				</div>

				<!-- Modal -->
				<!-- <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">...</div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary">Save changes</button>
                            </div>
                        </div>
                    </div>
                </div> -->
			</div>
		</div>
	</div>
</div>
